import React, { useState, useRef } from 'react';
import styled from 'styled-components';
import { keyBy } from 'lodash';
import { useUsers } from '../../../firebase/api/user';
import { sendInvitation, removeInvitation } from '../../../firebase/api/invitations';
import { useOnClickOutside } from '../../../hooks/useOnClickOutside';
import { useToasts } from 'react-toast-notifications';
import List, { Users } from '../List';
import NoUsersFound from '../NoUsersFound';
import closeImg from '../../../svg/close.svg';
import Notification from '../Notification';
// import windows from '../../../png/windows.png';
// import isWeb from '../../../utils/isWeb';

// const DownloadApp = styled.div`
//   display: flex;
//   margin-right: 10px;
//   align-items: center;
//   padding: 10px;
//   border-radius: 3px;
//   position: relative;
//   width: 100%;
//   background: rgba(0, 0, 0, 0.5);
//   color: #fff;
//   text-align: center;
//   z-index: 9999999;
//   a {
//     color: #fff;
//     margin: 5px 0px;
//     margin-left: 5px;
//     padding: 4px 0;
//     padding-left: 5px;
//     line-height: 17px;
//     transition: 0.3s ease-in-out;
//     background-image: linear-gradient(
//       to right,
//       rgb(31, 162, 255) 0%,
//       rgb(18, 216, 250) 51%,
//       rgb(31, 162, 255) 100%
//     );
//     color: #fff;
//     background-size: 200%;
//     display: flex;
//     align-items: center;
//     text-decoration: none;
//     img {
//       width: 25px;
//     }
//     &:hover {
//       background-position: right center;
//     }
//   }
//   @media screen and (max-width: 1200px) {
//     display: none;
//   }
// `;

const Invitation = styled.div<{ isLast: boolean }>`
  border: 1px solid #999;
  padding: 0px 2px;
  margin-bottom: ${(props) => (props.isLast ? '0' : '3px')};
  border-radius: 3px;
  position: relative;
  margin-right: 14px;

  .close {
    position: absolute;
    top: 3px;
    right: -17px;
    width: 11px;
    height: 11px;
    border: 1px solid #999;
    border-radius: 100%;
    background: #fff;
    cursor: pointer;
  }
`;

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
  align-items: center;
`;

const Exit = styled.div`
  cursor: pointer;
`;

const AsideRight = styled.div`
  display: flex;
  align-items: center;
`;

const Form = styled.form`
  display: flex;
  align: center;
  input {
    border: none;
    min-width: 250px;
    border-bottom: 1px dashed #999;
    padding: 5px 0;
    &:focus {
      outline: none;
    }
  }
  button {
    background-color: #fff;
    border: none;
    border: 1px dashed #999;
    border-bottom: none;
    cursor: pointer;
    transition: 0.3s ease-in-out;
    min-width: 180px;
    &:hover {
      background: #f1f1f1;
    }
  }
`;

const BoardTitle = styled.div`
  display: flex;
  justify-content: space-between;
  background: #fff;
  border: 1px solid #999;
  text-align: center;
  margin-bottom: 10px;
  padding: 5px;
`;

const SearchWrapper = styled.div`
  position: relative;
`;

const SearchUserItem = styled.div`
  width: 100%;
  padding: 5px;
  border-bottom: 1px solid #999;
  cursor: pointer;
  transition: 0.3s ease-in-out;
  &:hover {
    background: #f1f1f1;
  }
`;

interface IProps {
  email: string;
  exit: () => void;
  currentBoardTitle?: string;
  currentBoardId?: string;
  currentUserId: string;
  currentBoardInvitationsArray?: {
    id: string;
    name: string;
  }[];
}

const Header: React.FC<IProps> = (props) => {
  const { users: usersData } = useUsers();
  const users = usersData.filter((u) => u.email !== props.email);
  const { addToast } = useToasts();
  const ref = useRef(null);
  const [email, setEmail] = useState<string>('');
  const [listIsOpen, setListIsOpen] = useState<boolean>(false);
  const [chosenUIDToSend, setChosenUIDToSend] = useState<string>('');
  const [sending, setSending] = useState<boolean>(false);

  const usersById = keyBy(users, 'uid');

  const userMails = users.map((user) => user.email);

  const resetForm = () => {
    setEmail('');
    setChosenUIDToSend('');
  };

  const choseUser = (user: { email: string; uid: string }) => {
    setEmail(user.email);
    setListIsOpen(false);
    setChosenUIDToSend(user.uid);
  };

  const submit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (props.currentBoardTitle && props.currentBoardId) {
      try {
        setSending(true);
        await sendInvitation(
          { uid: chosenUIDToSend, email },
          {
            boardId: props.currentBoardId,
            boardName: props.currentBoardTitle,
          }
        );
        setSending(false);
        resetForm();
      } catch (e) {
        addToast('Не удалось отправить, попробуйте еще раз', {
          appearance: 'error',
          autoDismiss: true,
        });
      }
    }
  };

  useOnClickOutside(ref, () => setListIsOpen(false));

  return (
    <HeaderWrapper>
      <div>{props.email}</div>
      <Notification />
      {!!props.currentUserId && (
        <div>
          Статистика пользователя <b>{usersById[props.currentUserId]?.email}</b>
        </div>
      )}
      {!!props?.currentBoardTitle && (
        <Form onSubmit={submit}>
          <div>
            <BoardTitle>
              <div>{props?.currentBoardTitle}</div>
              <div>
                <div>
                  {!!props.currentBoardInvitationsArray?.length ? (
                    props.currentBoardInvitationsArray?.map((user, i, self) => (
                      <Invitation key={user.id} isLast={i === self.length - 1}>
                        <span>{user.name}</span>
                        <img
                          src={closeImg}
                          alt="close"
                          className="close"
                          onClick={() =>
                            props.currentBoardId && removeInvitation(user.id, props.currentBoardId)
                          }
                        />
                      </Invitation>
                    ))
                  ) : (
                    <span style={{ color: '#999' }}>Нету приглашенных</span>
                  )}
                </div>
              </div>
            </BoardTitle>
            <SearchWrapper>
              <input
                id="invitation-input"
                onFocus={() => setListIsOpen(true)}
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Поиск пользователя по E-mail"
              />
              <button
                type="submit"
                disabled={!chosenUIDToSend || sending || !userMails.includes(email)}
              >
                {sending ? 'Отправка...' : 'Отправить приглашение'}
              </button>
              {listIsOpen && email.length > 1 && (
                <List ref={ref}>
                  <Users>
                    {users
                      .filter(
                        (user) =>
                          user.email.includes(email) &&
                          !props.currentBoardInvitationsArray
                            ?.map((user) => user.id)
                            .includes(user.uid)
                      )
                      ?.map((user) => (
                        <SearchUserItem
                          key={user.uid}
                          onClick={() => choseUser({ email: user.email, uid: user.uid })}
                        >
                          {user.email}
                        </SearchUserItem>
                      ))}
                  </Users>
                  {!userMails.includes(email) && <NoUsersFound email={email} />}
                </List>
              )}
            </SearchWrapper>
          </div>
        </Form>
      )}
      <AsideRight>
        {/* {isWeb && (
          <DownloadApp>
            <span>Для трекинга времени</span>
            <a href="/smart-tracker Setup 0.1.0.exe">
              скачайте программу <img src={windows} alt="windows" />
            </a>
          </DownloadApp>
        )} */}
        <Exit onClick={props.exit}>Выход</Exit>
      </AsideRight>
    </HeaderWrapper>
  );
};

export default Header;
